export const info = {
  CELPHONE: '(602) 535-7231',
  EMAIL: 'info@redranchtrucking.com',
  ADDRESS: '29522 W Van Buren St. Buckeye, AZ 85396',
}
